import React from 'react';
import '../styles/Hero.css';
import logo from '../assets/logo.png';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="container hero-container">
        <div className="hero-content">
          <h1 className="slide-up">Komodo Classic (KMDCL)</h1>
          <h2 className="slide-up">Reviving the Essence of Komodo</h2>
          <p className="slide-up">
            A community-driven initiative dedicated to restoring and enhancing key features of the original Komodo blockchain.
            We're bringing back essential functionalities that were deprecated or changed, ensuring the Komodo ecosystem remains true to its roots.
          </p>
          <div className="hero-buttons slide-up">
            <a href="#features" className="btn btn-primary">Explore Features</a>
            {/* <a href="#donations" className="btn btn-outline">Support</a> */}
            <a href="https://github.com/kmdclassic/KmdClassic/releases/latest" target="_blank" rel="noopener noreferrer" className="btn btn-outline">Download Wallet</a>
          </div>
        </div>
        <div className="hero-image fade-in">
          <div className="hero-graphic">
            <img src={logo} alt="KMD Classic Logo" className="logo" />
          </div>
        </div>
      </div>
      <div className="hero-wave"></div>
    </section>
  );
};

export default Hero;
